import React, { Component, PropTypes } from 'react';
import { formatNumber, DateFormatter } from '../../utils/date';
import forEach from 'lodash/forEach';
import Image from '../image/image';
import { casesRoute } from '../../routes/index';
import { Link } from 'react-router';
import getCategoryName from '../../utils/getCategoryName';
import formatCredits from '../../utils/formatCredits';

import css from './caseElement.scss';

//tmp
import img from './placeholder.png';

export default class CaseElementMenu extends Component {
	static propTypes = {
		points: PropTypes.number.isRequired,
		showPoints: PropTypes.bool,
		item: PropTypes.shape({
			awards: PropTypes.array.isRequired,
			profiles: PropTypes.array.isRequired,
			createdDate: PropTypes.string.isRequired,
			caseTypes: PropTypes.shape({
				name: PropTypes.string.isRequired,
			}),
			title: PropTypes.string.isRequired,
			categories: PropTypes.array.isRequired,
			thumbnail: PropTypes.oneOfType([
				PropTypes.oneOf([false]),
				PropTypes.object,
			]),
			legacy: PropTypes.oneOf([0, 1, true, false]),
			days: PropTypes.number.isRequired,
		}).isRequired,
		browser: PropTypes.object.isRequired,
		menuActions: PropTypes.object.isRequired,
		menuActive: PropTypes.bool.isRequired,
	};

	static defaultProps = {
		points: 0,
		item: {
			awards: [],
			profiles: [],
			createdDate: '',
			caseTypes: {
				name: '',
			},
			title: '',
			categories: [],
			thumbnail: false,
			legacy: 1,
			days: 0,
		},
		showPoints: false,
		menuActive: false,
	};

	constructor(props) {
		super(props);

		//this.testbg = `rgb(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1})`;
		this.state = {};
	}

	render() {
		let createdDate = new DateFormatter(this.props.item.createdDate);
		let awardTitle = '';
		let awardType = '';
		let url = casesRoute(this.props.item.slug);

		let ribbonClass = '';

		let caseAward = false;
		forEach(this.props.item.awards, (award) => {
			if (this.props.awardId === award.id) {
				caseAward = award;
			}
		});

		if (caseAward) {
			awardTitle = caseAward.name;
			awardType = caseAward.type.toLowerCase();
			ribbonClass = `ribbon-${awardType} ribbon-${awardType}--small ribbon-${awardType}--br`;
		}

		let pointClass = 'span1 hide-tablet case-element__glitter-scorecard';
		let imageClass = 'span3 span4-tablet case-element__glitter-img pixel-pattern pixel-pattern--dark';

		if (!this.props.item.legacy) {
			pointClass = 'span1 case-element__glitter-scorecard';
			imageClass = 'span3 span4-tablet case-element__glitter-img pixel-pattern pixel-pattern--dark span10-mobile';
		}

		return (
			<div className='case-element'>
				<div className='case-element__glitter pixel-pattern clearfix'>
					<div className={imageClass}>
						<Link to={url} onClick={(e) => {
							this.props.menuActive && this.props.menuActions && this.props.menuActions.closeMenu();
						}}>
							<Image img={this.props.item.thumbnail} span={{ desktop: 'span3', tablet: 'span5' }} alt='' browser={this.props.browser} />
						</Link>
						{ribbonClass && (
						<div className={ribbonClass}></div>
						)}
						{ /* <img alt='placeholder' style={{ background: this.bg }} /> */ }
					</div>
					<div className={pointClass}>
						{this.props.item.legacy == 0 && (
						<div className='case-element__glitter-scorecard__score'>
							{formatNumber(this.props.item.points)} <small>Points</small>
						</div>
						) || null}
						{this.props.item.legacy == 0 && (
						<div className='case-element__glitter-scorecard__days'>
							{this.props.item.days} <small>Days</small>
						</div>
						) || null}
					</div>
				</div>
				<div className='case-element__details clearfix'>
					<div className='span3 span4-tablet case-element__details-holder span12-mobile'>
						<div className='case-element__details-award'>
							{awardTitle}
							<div className='case-element__details-award__category'>
								{awardType}
							</div>
						</div>
						<div className='case-element__details__title'>{this.props.item.title}</div>
						<div className='case-element__details__profile'>{formatCredits(this.props.item.profiles, false)}</div>
					</div>
					<div className='span1 hide-tablet empty'></div>
				</div>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/case/caseElementMenu.js
 **/